(() => {
  const getCartCount = async () => {
    try {
      const res = await fetch('/cart.js', { credentials: 'same-origin' });
      if (!res.ok) return null;
      const data = await res.json();
      return Number(data.item_count || 0);
    } catch (_) {
      return null;
    }
  };

  const init = () => {
    const modal = document.getElementById('pdp-atc-modal');
    if (!modal) return;

    const closeBtn = document.getElementById('pdp-atc-modal-close');
    const subtitle = document.getElementById('pdp-atc-modal-subtitle');
    const crosssell = document.getElementById('pdp-atc-crosssell') || document.getElementById('pdp-atc-upsell');
    const crosssellGrid =
      document.getElementById('pdp-atc-crosssell-grid') ||
      document.getElementById('pdp-atc-upsell');
    const divider = document.getElementById('pdp-atc-divider');
    const crosssellProductId = Number(crosssell?.getAttribute('data-product-id') || 0);
    const currentProductHandle = crosssell?.getAttribute('data-product-handle') || '';
    const primaryCollectionHandle = crosssell?.getAttribute('data-primary-collection-handle') || '';
    let isOpen = false;

    const formatMoney = (rawPrice) => {
      const price = Number(rawPrice);
      if (!Number.isFinite(price)) return '';
      const cents = price > 1000 ? price : Math.round(price * 100);
      return new Intl.NumberFormat('fr-FR', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      }).format(cents / 100);
    };

    const createCrosssellCard = (product) => {
      const variant = product?.variants?.find((v) => v.available) || product?.variants?.[0];
      if (!product || !variant) return null;
      const productHandle = (product.handle || '').toLowerCase();
      if (!productHandle || productHandle === currentProductHandle.toLowerCase()) return null;

      const article = document.createElement('article');
      article.className = 'pdp-atc-crosssell-item';
      article.setAttribute('data-product-handle', productHandle);
      article.innerHTML = `
        <a class="pdp-atc-crosssell-media" href="${product.url || '#'}">
          ${product.featured_image ? `<img class="pdp-atc-crosssell-thumb" src="${product.featured_image}" alt="${(product.title || '').replace(/"/g, '&quot;')}" loading="lazy" width="220" height="294">` : ''}
        </a>
        <div class="pdp-atc-crosssell-body">
          <a href="${product.url || '#'}" class="pdp-atc-crosssell-name">${product.title || ''}</a>
          <p class="pdp-atc-crosssell-price">${formatMoney(variant.price)}</p>
          <button type="button" class="pdp-atc-crosssell-add" data-variant-id="${variant.id}">Ajouter au panier</button>
        </div>
      `;
      return article;
    };

    const loadRelevantCrosssell = async () => {
      if (!crosssellGrid) return;
      const targetCount = 4;
      const existingCards = Array.from(crosssellGrid.querySelectorAll('.pdp-atc-crosssell-item'));
      const selected = [];
      const seenHandles = new Set();

      const addFromNode = (node) => {
        if (!node || selected.length >= targetCount) return;
        const handle = (node.getAttribute('data-product-handle') || '').toLowerCase();
        if (!handle || handle === currentProductHandle.toLowerCase() || seenHandles.has(handle)) return;
        seenHandles.add(handle);
        selected.push(node.cloneNode(true));
      };

      const addFromProducts = (products) => {
        products.forEach((product) => {
          if (selected.length >= targetCount) return;
          const node = createCrosssellCard(product);
          if (!node) return;
          const handle = (node.getAttribute('data-product-handle') || '').toLowerCase();
          if (!handle || seenHandles.has(handle)) return;
          seenHandles.add(handle);
          selected.push(node);
        });
      };

      existingCards.forEach(addFromNode);

      const fetchRecommendations = async (intent) => {
        if (!crosssellProductId || selected.length >= targetCount) return;
        try {
          const res = await fetch(
            `/recommendations/products.json?product_id=${crosssellProductId}&limit=8&intent=${intent}`,
            { credentials: 'same-origin' }
          );
          if (!res.ok) return;
          const data = await res.json();
          const products = Array.isArray(data?.products) ? data.products : [];
          addFromProducts(products);
        } catch (_) {
          // Continue with next source.
        }
      };

      const fetchCollectionProducts = async () => {
        if (!primaryCollectionHandle || selected.length >= targetCount) return;
        try {
          const res = await fetch(`/collections/${primaryCollectionHandle}/products.json?limit=20`, {
            credentials: 'same-origin',
          });
          if (!res.ok) return;
          const data = await res.json();
          const products = Array.isArray(data?.products) ? data.products : [];
          addFromProducts(products);
        } catch (_) {
          // Keep what we already have.
        }
      };

      await fetchRecommendations('related');
      await fetchRecommendations('complementary');
      await fetchCollectionProducts();

      if (!selected.length) {
        syncCrosssellVisibility();
        return;
      }

      const fragment = document.createDocumentFragment();
      selected.slice(0, targetCount).forEach((node) => fragment.appendChild(node));
      crosssellGrid.replaceChildren(fragment);
      syncCrosssellVisibility();
    };

    const syncCrosssellVisibility = () => {
      if (!crosssell) return;
      const items = crosssellGrid
        ? Array.from(
            crosssellGrid.querySelectorAll(
              '.pdp-atc-crosssell-item, .pdp-atc-upsell-item, .pdp-atc-crosssell-add, .pdp-atc-upsell-add'
            )
          )
        : [];
      const hasItems = items.length > 0;
      crosssell.style.display = hasItems ? '' : 'none';
      if (divider) divider.style.display = hasItems ? '' : 'none';
    };

    const openModal = (subtitleText) => {
      if (subtitleText && subtitle) subtitle.textContent = subtitleText;
      syncCrosssellVisibility();
      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('overflow-hidden');
      isOpen = true;
    };

    const closeGlobalLayer = () => {
      const panel = document.getElementById('panel-cart');
      if (panel) {
        panel.classList.remove('is-active');
        panel.removeAttribute('open');
        panel.setAttribute('aria-hidden', 'true');
      }

      document.querySelectorAll('global-overlay').forEach((overlay) => {
        overlay.classList.remove('is-active');
        overlay.style.opacity = '0';
        overlay.style.pointerEvents = 'none';
      });

      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
      window.$WM?.resetOverlayHistory?.();
    };

    const closeModal = () => {
      modal.hidden = true;
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('overflow-hidden');
      closeGlobalLayer();
      isOpen = false;
    };

    const waitForAddToCart = async (beforeCount) => {
      const started = Date.now();
      while (Date.now() - started < 5000) {
        const count = await getCartCount();
        if (count !== null && count > beforeCount) {
          openModal('Votre panier a bien été mis à jour.');
          return;
        }
        await new Promise((resolve) => setTimeout(resolve, 300));
      }
      openModal('Votre panier a bien été mis à jour.');
    };

    closeBtn?.addEventListener('click', closeModal);
    modal.querySelector('[data-pdp-atc-continue-shopping]')?.addEventListener('click', closeModal);

    modal.addEventListener('click', (event) => {
      if (event.target && event.target.hasAttribute('data-pdp-atc-close')) {
        closeModal();
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && isOpen) {
        closeModal();
      }
    });

    document.addEventListener('click', (event) => {
      const addButton = event.target.closest('[data-main-add-to-cart]');
      if (!addButton) return;

      getCartCount().then((beforeCount) => {
        if (beforeCount !== null) {
          window.setTimeout(() => waitForAddToCart(beforeCount), 120);
        } else {
          window.setTimeout(() => openModal('Votre panier a bien été mis à jour.'), 700);
        }
      });
    });

    document.addEventListener('click', async (event) => {
      const quickAddBtn = event.target.closest('.pdp-atc-crosssell-add');
      if (!quickAddBtn) return;

      const variantId = quickAddBtn.getAttribute('data-variant-id');
      if (!variantId) return;

      quickAddBtn.classList.add('is-loading');

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ id: Number(variantId), quantity: 1 }),
        });

        if (res.ok) {
          quickAddBtn.classList.remove('is-loading');
          quickAddBtn.classList.add('is-added');
          quickAddBtn.textContent = 'Ajouté';
          if (subtitle) subtitle.textContent = 'Produit complémentaire ajouté au panier.';
          document.dispatchEvent(new Event('cart:updated'));
        } else {
          quickAddBtn.classList.remove('is-loading');
        }
      } catch (_) {
        quickAddBtn.classList.remove('is-loading');
      }
    });

    syncCrosssellVisibility();
    loadRelevantCrosssell();
    if (crosssellGrid) {
      new MutationObserver(syncCrosssellVisibility).observe(crosssellGrid, {
        childList: true,
        subtree: true,
      });
    }

    window.pdpAtcToast = {
      open: openModal,
      close: closeModal,
    };
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
